export default __webpack_public_path__ + "static/bg2-fa390333552e42087f29201184076f84.svg";